import { REACT_QUERY_KEYS } from '@/constants'

export const packageCategoriesQueryKeys = {
  all: [REACT_QUERY_KEYS.PACKAGE_CATEGORIES] as const,
  select: (tenantKey: string, dcId?: number) =>
    [...packageCategoriesQueryKeys.all, 'select', tenantKey, dcId] as const
}
